export { colorVarNames, fontVarNames } from './theme';

export { AppShell } from './composites/AppShell';
export type { AppShellProps } from './composites/AppShell/AppShell.types';

export type { MobileTabItem } from './components/MobileTabBar/MobileTabBar.types';
export type { SideNavItem } from './components/SideNav/SideNav.types';

export { SpaListTemplate } from './templates/SpaListTemplate';
export type {
  SpaListCategoryOption,
  SpaListDurationOption,
  SpaListItem,
  SpaListTemplateProps,
} from './templates/SpaListTemplate/SpaListTemplate.types';

export { SpaDayDetailTemplate } from './templates/SpaDayDetailTemplate';
export type { SpaDayDetailTemplateProps } from './templates/SpaDayDetailTemplate';

export { JourneyPicker } from './composites/JourneyPicker';
export type {
  JourneyPickerCategory,
  JourneyPickerLabels,
  JourneyPickerProps,
  JourneyPickerSearchParams,
} from './composites/JourneyPicker/JourneyPicker.types';

export { Recommendations } from './composites/Recommendations';
export type { RecommendationItem, RecommendationsProps } from './composites/Recommendations';

export { ExtrasTemplate } from './templates/ExtrasTemplate';
export type {
  ExtrasGuest,
  ExtrasItem,
  ExtrasTemplateLabels,
  ExtrasTemplateProps,
} from './templates/ExtrasTemplate/ExtrasTemplate.types';

export { SpaDaysBookingForm } from './templates/SpaDaysBookingForm';
export type {
  AllOptionsConfig,
  DayAvailability,
  GuestConfig,
  OptionsPanelConfig,
  SingleOptionConfig,
  SpaDaysBookingFormLabels,
  SpaDaysBookingFormProps,
  StickyFooterProps,
  TimeslotOption,
} from './templates/SpaDaysBookingForm/SpaDaysBookingForm.types';

export { HomeTemplate } from './templates/HomeTemplate';
export type { CategoryItem, HomeTemplateProps } from './templates/HomeTemplate/HomeTemplate.types';

export { SpaTreatmentFacilityDetailTemplate } from './templates/SpaTreatmentFacilityDetailTemplate';
export type { SpaTreatmentFacilityTemplateProps } from './templates/SpaTreatmentFacilityDetailTemplate/SpaTreatmentFacilityDetailTemplate.types';
